<script setup lang="ts">
import {isVNode} from 'vue'
import {useToast} from './use-toast'
import {Toast, ToastDescription, ToastProvider, ToastTitle, ToastViewport} from '.'

const {toasts} = useToast()
</script>

<template>
  <ToastProvider>
    <Toast v-for="toast in toasts" :key="toast.id" v-bind="toast">
      <div class="grid gap-1">
        <ToastTitle class="font-bold flex gap-3 items-center" v-if="toast.title">
          <Loading v-if="toast.loading" class="!mt-0"/>
          {{ toast.title }}
        </ToastTitle>
        <template v-if="toast.description">
          <ToastDescription class="font-semibold" v-if="isVNode(toast.description)">
            <component :is="toast.description"/>
          </ToastDescription>
          <ToastDescription class="font-semibold" v-else>
            {{ toast.description }}
          </ToastDescription>
        </template>
        <!--        <ToastClose/>-->
      </div>
      <component :is="toast.action"/>
    </Toast>
    <ToastViewport/>
  </ToastProvider>
</template>
